import React from 'react';

export const Click = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_850_36838)">
      <path
        d="M6.1665 8.96663V3.58333C6.1665 3.33137 6.26659 3.08974 6.44475 2.91158C6.62291 2.73342 6.86454 2.63333 7.1165 2.63333C7.36845 2.63333 7.61009 2.73342 7.78825 2.91158C7.96641 3.08974 8.06649 3.33137 8.06649 3.58333V8.3333"
        stroke="#1F2937"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.06641 8.01664V6.74998C8.06641 6.49803 8.16649 6.25639 8.34465 6.07823C8.52281 5.90008 8.76445 5.79999 9.0164 5.79999C9.26836 5.79999 9.50999 5.90008 9.68815 6.07823C9.86631 6.25639 9.9664 6.49803 9.9664 6.74998V8.33331"
        stroke="#1F2937"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.96631 7.38331C9.96631 7.13136 10.0664 6.88972 10.2446 6.71157C10.4227 6.53341 10.6643 6.43332 10.9163 6.43332C11.1683 6.43332 11.4099 6.53341 11.5881 6.71157C11.7662 6.88972 11.8663 7.13136 11.8663 7.38331V8.33331"
        stroke="#1F2937"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.867 8.01665C11.867 7.76469 11.9671 7.52306 12.1453 7.3449C12.3234 7.16674 12.5651 7.06665 12.817 7.06665C13.069 7.06665 13.3106 7.16674 13.4888 7.3449C13.6669 7.52306 13.767 7.76469 13.767 8.01665V10.8666C13.767 11.8744 13.3667 12.841 12.654 13.5536C11.9414 14.2663 10.9749 14.6666 9.96704 14.6666H8.70038H8.83211C8.2028 14.6667 7.58331 14.5105 7.02927 14.2121C6.47523 13.9136 6.00399 13.4822 5.65786 12.9566L5.53373 12.7666C5.33613 12.4633 4.64264 11.2542 3.45261 9.13891C3.33129 8.92328 3.29889 8.66883 3.36228 8.42967C3.42568 8.19052 3.57987 7.98553 3.79207 7.85831C4.01809 7.7227 4.28295 7.66649 4.54457 7.69862C4.80619 7.73074 5.04958 7.84937 5.23607 8.03565L6.16706 8.96664"
        stroke="#1F2937"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.26712 2.63333L3.63379 2"
        stroke="#1F2937"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.63333 5.16666H3"
        stroke="#1F2937"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.96631 2.63333L10.5996 2"
        stroke="#1F2937"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6001 4.53333H11.2334"
        stroke="#1F2937"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_850_36838">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
